import { defineComponent } from 'vue';

const templateElement = document.getElementById('color-text-template');
export default defineComponent({
  template: templateElement ? templateElement.innerHTML : '',
  props: {
    active: {
      type: Object,
      required: true,
    },
  },
});
